(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-omtilo"] && !Shopify.designMode) return;
  try {
    
  class OmtiloAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.messages = this.querySelectorAll('.o-announce__msg');
      if (this.messages.length < 2) return;
      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 3800;
      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.messages[this.index];
      current.classList.remove('on');
      current.setAttribute('aria-hidden', 'true');
      this.index = (this.index + 1) % this.messages.length;
      const upcoming = this.messages[this.index];
      upcoming.classList.add('on');
      upcoming.removeAttribute('aria-hidden');
    }
  }

  if (!customElements.get('omtilo-announcement-bar')) {
    customElements.define('omtilo-announcement-bar', OmtiloAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card-omtilo"] && !Shopify.designMode) return;
  try {
    
  class OmtiloGiftCard extends HTMLElement {
    connectedCallback() {
      this.visual = this.querySelector('[data-gc-visual]');
      this.amountLabel = this.querySelector('[data-gc-amount]');
      this.variantInput = this.querySelector('input[name="id"]');

      this.querySelectorAll('[data-gc-variant]').forEach((pill) => {
        pill.addEventListener('click', () => {
          this.variantInput.value = pill.dataset.gcVariant;
          if (this.amountLabel) this.amountLabel.textContent = pill.dataset.gcPrice;
          this.querySelectorAll('[data-gc-variant]').forEach((other) => {
            const selected = other === pill;
            other.classList.toggle('is-selected', selected);
            other.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
      });

    }
  }

  if (!customElements.get('omtilo-gift-card')) {
    customElements.define('omtilo-gift-card', OmtiloGiftCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-omtilo"] && !Shopify.designMode) return;
  try {
    
  class OmtiloHeader extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-nav-dialog]');
      this.openButton = this.querySelector('[data-nav-open]');
      this.closeButton = this.querySelector('[data-nav-close]');

      this.openButton?.addEventListener('click', () => this.openNav());
      this.closeButton?.addEventListener('click', () => this.closeNav());
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.closeNav();
      });
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.closeNav();
      });
      this.dialog?.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.closeNav());
      });

      this.setHeights();
      window.addEventListener('resize', () => this.setHeights());
    }

    setHeights() {
      const group = document.getElementById('header-group');
      document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
      if (group) {
        document.body.style.setProperty('--header-group-height', `${group.offsetHeight}px`);
      }
    }

    openNav() {
      if (!this.dialog) return;
      this.dialog.showModal();
      this.openButton?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    closeNav() {
      if (!this.dialog || !this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      this.openButton?.setAttribute('aria-expanded', 'false');
      const finish = () => this.dialog.close();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        this.dialog.addEventListener('transitionend', finish, { once: true });
      }
    }
  }

  if (!customElements.get('omtilo-header')) {
    customElements.define('omtilo-header', OmtiloHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-omtilo"]) return;
  try {
    
  class OmtiloGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('.o-gallery__thumbs button'));
      this.images = Array.from(this.querySelectorAll('.o-gallery__image'));
      this.current = 0;
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.select(thumb.dataset.mediaIndex));
      });
      this.setupThumbScrollCue();
      this.setupLightbox();
    }

    /* Fade the scroll edges when the thumbnail list overflows, so a capped
       column/row still signals there are more photos to scroll to. */
    setupThumbScrollCue() {
      const el = this.querySelector('.o-gallery__thumbs');
      if (!el) return;
      const update = () => {
        const horizontal = getComputedStyle(el).flexDirection === 'row';
        const pos = horizontal ? el.scrollLeft : el.scrollTop;
        const size = horizontal ? el.clientWidth : el.clientHeight;
        const total = horizontal ? el.scrollWidth : el.scrollHeight;
        el.classList.toggle('has-more-start', pos > 4);
        el.classList.toggle('has-more-end', pos + size < total - 4);
      };
      el.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    select(index) {
      index = String(index);
      this.current = parseInt(index, 10) || 0;
      this.images.forEach((image) => {
        image.hidden = image.dataset.mediaIndex !== index;
      });
      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaIndex === index);
      });
    }

    /* ---- fullscreen lightbox with zoom / pan / pinch ---- */
    setupLightbox() {
      this.dialog = this.querySelector('[data-lightbox]');
      if (!this.dialog) return;
      this.lbImg = this.dialog.querySelector('[data-lb-img]');
      this.lbStage = this.dialog.querySelector('[data-lb-stage]');
      this.lbCount = this.dialog.querySelector('[data-lb-count]');
      this.lbThumbs = Array.from(this.dialog.querySelectorAll('[data-lb-thumb]'));
      this.zoomSources = this.images.map((img) => ({
        preview: img.currentSrc || img.src,
        zoom: img.dataset.zoomSrc || img.currentSrc || img.src,
        alt: img.alt || '',
      }));

      const openBtn = this.querySelector('[data-zoom-open]');
      if (openBtn) openBtn.addEventListener('click', () => this.openLightbox(this.current));
      this.images.forEach((img) => {
        img.addEventListener('click', () => this.openLightbox(parseInt(img.dataset.mediaIndex, 10) || 0));
      });

      const closeBtn = this.dialog.querySelector('[data-lb-close]');
      const prevBtn = this.dialog.querySelector('[data-lb-prev]');
      const nextBtn = this.dialog.querySelector('[data-lb-next]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.dialog.close());
      if (prevBtn) prevBtn.addEventListener('click', () => this.lbGo(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.lbGo(1));
      this.lbThumbs.forEach((t) => t.addEventListener('click', () => this.lbShow(parseInt(t.dataset.mediaIndex, 10) || 0)));

      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.lbGo(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.lbGo(1); }
      });
      this.dialog.addEventListener('close', () => {
        this.select(String(this.lbIndex || 0));
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      });

      this.setupZoom();
    }

    openLightbox(index) {
      this.lastFocus = document.activeElement;
      this.lbShow(index);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    lbShow(index) {
      const n = this.zoomSources.length;
      if (!n) return;
      this.lbIndex = ((index % n) + n) % n;
      const src = this.zoomSources[this.lbIndex];
      this.resetZoom();
      if (src) {
        // Don't set any pixel width/height here: CSS (width/height:auto +
        // max-width/height:100% + object-fit:contain) sizes the image to the
        // stage at its true ratio. Forcing natural dimensions made a square
        // 2048×2048 box overflow the landscape stage (cropped, un-zoom-outable).
        // show the already-decoded gallery image instantly, then upgrade to
        // the high-res zoom source once it has loaded (no blank flash)
        this.lbImg.src = src.preview;
        this.lbImg.alt = src.alt;
        if (src.zoom && src.zoom !== src.preview) {
          const target = this.lbIndex;
          const hi = new Image();
          hi.onload = () => { if (this.lbIndex === target) this.lbImg.src = src.zoom; };
          hi.src = src.zoom;
        }
      }
      if (this.lbCount) this.lbCount.textContent = (this.lbIndex + 1) + ' / ' + n;
      this.lbThumbs.forEach((t) => {
        t.classList.toggle('is-active', parseInt(t.dataset.mediaIndex, 10) === this.lbIndex);
      });
    }

    lbGo(delta) { this.lbShow((this.lbIndex || 0) + delta); }

    setupZoom() {
      this.scale = 1; this.tx = 0; this.ty = 0;
      this.pointers = new Map();
      this.pinchStart = null;
      this.dragged = false;

      this.lbImg.addEventListener('click', (e) => {
        if (this.dragged) { this.dragged = false; return; }
        if (this.scale > 1) this.resetZoom();
        else this.zoomTo(2.5, e);
      });

      this.lbStage.addEventListener('wheel', (e) => {
        e.preventDefault();
        const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
        this.zoomTo(this.scale * factor, e);
      }, { passive: false });

      this.lbImg.addEventListener('pointerdown', (e) => {
        this.lbImg.setPointerCapture(e.pointerId);
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (this.pointers.size === 2) {
          const pts = [...this.pointers.values()];
          this.pinchStart = { dist: this.dist(pts[0], pts[1]), scale: this.scale };
          this.dragged = true;
        }
      });
      this.lbImg.addEventListener('pointermove', (e) => {
        if (!this.pointers.has(e.pointerId)) return;
        const prev = this.pointers.get(e.pointerId);
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (this.pointers.size === 2 && this.pinchStart) {
          const pts = [...this.pointers.values()];
          const ratio = this.dist(pts[0], pts[1]) / this.pinchStart.dist;
          this.setScale(this.pinchStart.scale * ratio);
          this.lbImg.classList.toggle('is-zoomed', this.scale > 1);
          this.clampPan(); this.applyTransform();
        } else if (this.scale > 1) {
          const dx = e.clientX - prev.x, dy = e.clientY - prev.y;
          if (Math.abs(dx) + Math.abs(dy) > 3) { this.dragged = true; this.lbImg.classList.add('is-panning'); }
          this.tx += dx; this.ty += dy; this.clampPan(); this.applyTransform();
        }
      });
      const end = (e) => {
        this.pointers.delete(e.pointerId);
        this.lbImg.classList.remove('is-panning');
        if (this.pointers.size < 2) this.pinchStart = null;
      };
      this.lbImg.addEventListener('pointerup', end);
      this.lbImg.addEventListener('pointercancel', end);
    }

    dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    setScale(s) {
      this.scale = Math.min(4, Math.max(1, s));
      if (this.scale === 1) { this.tx = 0; this.ty = 0; }
    }

    zoomTo(s, evt) {
      const prev = this.scale;
      this.setScale(s);
      if (evt && this.scale !== prev) {
        const rect = this.lbImg.getBoundingClientRect();
        const cx = evt.clientX - (rect.left + rect.width / 2);
        const cy = evt.clientY - (rect.top + rect.height / 2);
        const ratio = this.scale / prev;
        this.tx = (this.tx - cx) * ratio + cx;
        this.ty = (this.ty - cy) * ratio + cy;
      }
      this.lbImg.classList.toggle('is-zoomed', this.scale > 1);
      this.clampPan(); this.applyTransform();
    }

    clampPan() {
      const stage = this.lbStage.getBoundingClientRect();
      const maxX = Math.max(0, (this.lbImg.offsetWidth * this.scale - stage.width) / 2);
      const maxY = Math.max(0, (this.lbImg.offsetHeight * this.scale - stage.height) / 2);
      this.tx = Math.min(maxX, Math.max(-maxX, this.tx));
      this.ty = Math.min(maxY, Math.max(-maxY, this.ty));
    }

    resetZoom() {
      this.scale = 1; this.tx = 0; this.ty = 0;
      if (this.lbImg) {
        this.lbImg.classList.remove('is-zoomed', 'is-panning');
        this.applyTransform();
      }
    }

    applyTransform() {
      this.lbImg.style.transform = 'translate(' + this.tx + 'px, ' + this.ty + 'px) scale(' + this.scale + ')';
    }
  }

  if (!customElements.get('omtilo-gallery')) {
    customElements.define('omtilo-gallery', OmtiloGallery);
  }

  // Opens Judge.me's write-review modal without a widget block on the page:
  // the Core app embed exposes jdgm.loadScript/loadCSS globally; form.css must
  // be live BEFORE the modal mounts or its fadeIn check misfires. The modal
  // resolves the product title itself (ShopifyAnalytics/og:title on the PDP).
  let omtiloJdgmModal = null;

  // Without a widget block the modal can't resolve product context itself —
  // add the image + title to the intro page from our own data (cosmetic:
  // if Judge.me ever renames these classes the modal still works, bare).
  const omtiloDecorateModal = (modal, info) => {
    try {
      const $ = jdgm.$;
      const intro = modal.$modal.find('.jdgm-write-review-modal__page--review-form-intro');
      if (!intro.length || intro.find('.jdgm-write-review-modal__product-title').length) return;
      const anchor = intro.find('.jdgm-write-review-modal__field-group--stars, .jdgm-write-review-modal__stars').first();
      if (!anchor.length) return;
      if (info.title) {
        $('<div class="jdgm-write-review-modal__product-title"></div>').text(info.title).insertBefore(anchor);
      }
      if (info.image) {
        const img = $('<div class="jdgm-write-review-modal__product-image"><img alt=""></div>');
        img.find('img').attr('src', info.image).attr('alt', info.title || '');
        img.insertBefore(intro.find('.jdgm-write-review-modal__product-title'));
      }
    } catch (error) {
      /* cosmetic only */
    }
  };

  const omtiloOpenWriteModal = (productId, info) => {
    if (!window.jdgm || typeof window.jdgm.loadScript !== 'function') return;
    if (omtiloJdgmModal) {
      omtiloJdgmModal.then((modal) => modal && modal.showModalPage());
      return;
    }
    omtiloJdgmModal = new Promise((resolve) => {
      const cssReady = new Promise((res) => {
        jdgm.loadCSS(jdgm.widgetPath('form.css'), res);
        setTimeout(res, 3000);
      });
      cssReady.then(() => {
        if (typeof jdgm._WriteReviewModal !== 'function' || !jdgm.$) {
          jdgm.loadScript('shopify_v2.js');
        }
        let tries = 0;
        const wait = setInterval(() => {
          tries += 1;
          if (typeof jdgm._WriteReviewModal === 'function' && jdgm.$) {
            clearInterval(wait);
            const modal = new jdgm._WriteReviewModal(jdgm.$);
            modal
              .setup('jdgm-review-widget-modal', productId)
              .then(() => {
                omtiloDecorateModal(modal, info);
                modal.showModalPage();
                resolve(modal);
              })
              .catch(() => resolve(null));
          } else if (tries === 30 && typeof jdgm._WriteReviewModal !== 'function') {
            jdgm.loadScript(jdgm.CDN_HOST + 'widget/write_review_modal.js');
          } else if (tries > 80) {
            clearInterval(wait);
            resolve(null);
          }
        }, 100);
      });
    });
  };

  // Analytics: subscribe_selected (SHOPIFY-CONFIG-SPEC.md §7) — routed via
  // omtilo-analytics.liquid's shared 'omtilo:custom-event' listener, same
  // mechanism as route_helper_click. (set_vs_single lives in
  // omtilo-analytics.liquid itself, tagged onto the existing add_to_cart
  // listener — see that file.)
  const omtiloDispatchCustomEvent = (name, params) => {
    document.dispatchEvent(new CustomEvent('omtilo:custom-event', { detail: { name, params } }));
  };

  document.addEventListener('click', (event) => {
    const writeButton = event.target.closest('[data-write-review]');
    if (writeButton) {
      omtiloOpenWriteModal(parseInt(writeButton.dataset.productId, 10), {
        title: writeButton.dataset.productTitle || '',
        image: writeButton.dataset.productImage || '',
      });
      return;
    }
    const addButton = event.target.closest('button[name="add"]');
    if (!addButton) return;
    const form = addButton.closest('form');
    const planInput = form && form.querySelector('[data-selling-plan-input]');
    if (!planInput) return;
    const freqSel = form.querySelector('[data-freq-selector] input:checked');
    planInput.value = addButton.dataset.subscribePlan ? ((freqSel && freqSel.value) || addButton.dataset.subscribePlan) : '';

    if (addButton.dataset.subscribePlan) {
      const productId = addButton.closest('product-form-component')?.dataset.productId || '';
      const variantInput = form.querySelector('[name="id"]');
      omtiloDispatchCustomEvent('subscribe_selected', {
        product_id: productId,
        variant_id: (variantInput && variantInput.value) || '',
        selling_plan_id: addButton.dataset.subscribePlan,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starthelp-omtilo"] && !Shopify.designMode) return;
  try {
    
  // Analytics: route_helper_click (SHOPIFY-CONFIG-SPEC.md §7) — routed via
  // omtilo-analytics.liquid's shared 'omtilo:custom-event' listener.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-route-helper]');
    if (!link) return;
    document.dispatchEvent(
      new CustomEvent('omtilo:custom-event', {
        detail: {
          name: 'route_helper_click',
          params: {
            route: link.dataset.routeTitle || '',
            link_url: link.getAttribute('href') || '',
          },
        },
      })
    );
  });

  } catch(e) { console.error(e); }
})();
})();
